/**
 * SVG icon for environment aspect
 */
import classnames from 'classnames';
import React, { PropTypes } from 'react';

function SymbolEnvironmentBig({ hoveredAspect }) {
  return (
    <symbol
      className="wheel-icon"
      id="icon-environment"
      viewBox="0 0 103.8 117.7"
    >
      <g>
        <path
          className={classnames({
            'is-hovered': hoveredAspect === 'tid:64',
            st0: true,
          })}
          d="M17.6,20.8l1.1,1.3c0,0-7.9-1.5-11.8-1.2c-3.9,0.3-3.9,4.7-3.9,5c0.8,1.1,2,1.9,3.4,2.1l19.2,2.7l1.6,2h0 L17.6,20.8z"
        />
        <path
          className={classnames({
            'is-hovered': hoveredAspect === 'tid:64',
            st1: true,
          })}
          d="M6.8,20.9c4-0.3,11.8,1.2,11.8,1.2l-1.1-1.3L16.1,19l-8.4-1.2c-2.8-0.4-5.3,1.6-5.7,4.3 c-0.2,1.3,0.2,2.6,0.9,3.6C2.9,25.6,2.9,21.1,6.8,20.9z"
        />
      </g>
      <g>
        <path
          className={classnames({
            'is-hovered': hoveredAspect === 'tid:64',
            st0: true,
          })}
          d="M24.9,57.3c-4.7,0.5-3.9,6-3.9,6c1,1.4,2.7,2.3,4.5,2.3c0.1,0,0.3,0,0.4,0l26.5-1.8l-6.3-7.8 C46.1,55.9,29.5,56.8,24.9,57.3z"
        />
        <path
          className={classnames({
            'is-hovered': hoveredAspect === 'tid:64',
            st0: true,
          })}
          d="M14.5,39c-4.2-0.1-4.2,3.6-4.2,3.7c0.8,1.8,2.5,3.1,4.6,3.1l23.3,0.5c0,0,0.1,0,0.1,0c0,0,0,0,0.1,0l-5.8-7.1 C32.5,39.2,18.7,39.1,14.5,39z"
        />
        <polygon
          className={classnames({
            'is-hovered': hoveredAspect === 'tid:64',
            st0: true,
          })}
          points="69,84.2 70.5,86 70.5,86   "
        />
        <path
          className={classnames({
            'is-hovered': hoveredAspect === 'tid:64',
            st0: true,
          })}
          d="M55.8,93c-7,0.6-6,6.6-6,6.7c1.3,2,3.6,3.3,6.1,3.3c0.1,0,0.3,0,0.4,0l26-1.6c0.2,0,0.3,0,0.5-0.1l-7.8-9.6 C75.1,91.7,62.8,92.3,55.8,93z"
        />
        <path
          className={classnames({
            'is-hovered': hoveredAspect === 'tid:64',
            'no-hover': true,
            st0: true,
          })}
          d="M60.8,74.1c0,0-20.5,1.6-24.9,2.1c-4.3,0.5-4.7,5.5-4.7,5.6c1.1,2.2,3.4,3.7,6,3.7c0.2,0,0.3,0,0.5,0l30.1-2.3 c0.1,0,0.2,0,0.3,0L60.8,74.1L60.8,74.1z"
        />
        <path
          className={classnames({
            'is-hovered': hoveredAspect === 'tid:64',
            st1: true,
          })}
          d="M101.9,109.9c0,0-2.8,4.6-6.4,0C91.7,105.3,11,8.7,11,8.7s-2.6-2.4,0-6c-0.4,0.2-0.7,0.4-1.1,0.7 c-2.2,1.8-2.5,5-0.7,7.1l7,8.6l11,13.5l5.4,6.7l5.8,7.1l4.7,5.8l0.6,0.8l2.4,2.9l6.3,7.8l2.6,3.2l2.9,3.5l3,3.7l7.4,9.1l0.9,1.1 l1.5,1.8l1.2,1.5l3.4,4.2l7.8,9.6l10,12.3c1,1.2,2.5,1.9,3.9,1.9c1.1,0,2.3-0.4,3.2-1.1C101.4,113.2,102,111.5,101.9,109.9z"
        />
        <path
          className={classnames({
            'is-hovered': hoveredAspect === 'tid:64',
            st1: true,
          })}
          d="M55.8,93c7-0.6,19.3-1.3,19.3-1.3l-3.4-4.2L70.5,86h0l1.1,1.3l-16.1,1c-4,0.2-7.1,3.7-6.9,7.8 c0.1,1.3,0.5,2.6,1.2,3.6C49.8,99.5,48.9,93.6,55.8,93z"
        />
        <path
          className={classnames({
            'is-hovered': hoveredAspect === 'tid:64',
            st1: true,
          })}
          d="M35.9,76.2c4.4-0.5,24.9-2.1,24.9-2.1l0,0l-3-3.7L36.7,72c-3.7,0.3-6.5,3.5-6.2,7.2c0.1,0.9,0.3,1.8,0.7,2.6 C31.2,81.6,31.6,76.6,35.9,76.2z"
        />
        <path
          className={classnames({
            'is-hovered': hoveredAspect === 'tid:64',
            st1: true,
          })}
          d="M24.9,57.3c4.7-0.5,21.2-1.4,21.2-1.4L43.7,53l-18.6,1.3c-3.1,0.2-5.4,2.9-5.2,6c0.1,1.1,0.5,2.1,1.1,3 C21,63.2,20.2,57.7,24.9,57.3z"
        />
        <path
          className={classnames({
            'is-hovered': hoveredAspect === 'tid:64',
            st1: true,
          })}
          d="M14.5,39c4.3,0.1,18,0.2,18,0.2l-5.4-6.7h0l2.8,3.5L15,35.8c0,0-0.1,0-0.1,0c-2.8,0-5,2.2-5.1,5 c0,0.7,0.1,1.4,0.4,2C10.2,42.6,10.3,39,14.5,39z"
        />
        <path
          className={classnames({
            'is-hovered': hoveredAspect === 'tid:64',
            st1: true,
          })}
          d="M29.1,8.1c0.2-1.6,0.4-5.6,4.7-4.3c-0.5-0.2-0.9-0.4-1.5-0.5c-2.8-0.5-5.4,1.3-5.9,4.1l-1.3,6.8l2.5,2.9 C27.7,17.1,28.9,10.4,29.1,8.1z"
        />
      </g>
      <path
        className={classnames({
          'is-hovered': hoveredAspect === 'tid:64',
          st1: true,
        })}
        d="M45.7,17.9c0.6-4.2,4-3.9,4.4-3.9c-0.5-0.3-1.1-0.5-1.7-0.6c-2.8-0.4-5.4,1.5-5.8,4.2l-2.3,15.1L43,36 C43,36,45.1,22.4,45.7,17.9z"
      />
      <path
        className={classnames({
          'is-hovered': hoveredAspect === 'tid:64',
          st1: true,
        })}
        d="M61.4,32.2c1.4-4.5,4.6-3.8,5-3.7c-0.4-0.2-0.8-0.4-1.2-0.5c-3-0.9-6.1,0.8-7,3.8l-5,16.8l2.6,3 C55.8,51.6,59.9,36.9,61.4,32.2z"
      />
      <path
        className={classnames({
          'is-hovered': hoveredAspect === 'tid:64',
          st1: true,
        })}
        d="M76.6,46.6c1.7-4.9,5.7-4.1,5.9-4c-0.3-0.2-0.7-0.3-1-0.5c-3.5-1.2-7.4,0.7-8.6,4.2l-6.4,18.7l2.7,3.4 C69.1,68.3,74.8,51.7,76.6,46.6z"
      />
      <g>
        <path
          className={classnames({
            'is-hovered': hoveredAspect === 'tid:64',
            st0: true,
          })}
          d="M100.7,107.2l-9.3-11.4l6.2-24.6c0.8-3.2-0.6-6.4-3.2-8c-0.1,0-4.6-1.6-6.6,5c-2,6.6-5,17.9-5,17.9L80,81.6 l-3.5-4.3l9.2-26.6c1.1-3.2-0.3-6.6-3.1-8.1c-0.3-0.1-4.2-0.9-5.9,4c-1.8,5.1-7.5,21.7-7.5,21.7l-2.7-3.4l-4.6-5.7L69,35 c0.8-2.6-0.4-5.2-2.6-6.5c-0.4-0.1-3.6-0.8-5,3.7c-1.5,4.8-5.6,19.4-5.6,19.4l-2.6-3L49,43.5l3.7-24.3c0.3-2.2-0.8-4.2-2.6-5.2 c-0.4-0.1-3.8-0.4-4.4,3.9C45.1,22.4,43,36,43,36l-2.6-3.1l-6.8-8.3l2.8-15.3c0.4-2.2-0.7-4.4-2.6-5.4c-4.3-1.3-4.5,2.7-4.7,4.3 c-0.3,2.2-1.4,8.9-1.4,8.9l-2.5-2.9L17,4.1c-1.5-1.8-4-2.3-6.1-1.4c-2.6,3.6,0,6,0,6s80.7,96.6,84.4,101.2c3.7,4.6,6.4,0.1,6.4,0 C101.8,108.9,101.4,108,100.7,107.2z"
        />
        <path
          className={classnames({
            'is-hovered': hoveredAspect === 'tid:64',
            st1: true,
          })}
          d="M87.9,68.2c2-6.5,6.5-5,6.6-5c-0.6-0.4-1.3-0.7-2.1-0.9c-3.9-1-7.9,1.4-8.9,5.3l-3.6,14l2.9,4.4 C82.9,86,85.9,74.8,87.9,68.2z"
        />
      </g>
    </symbol>
  );
}

SymbolEnvironmentBig.propTypes = {
  hoveredAspect: PropTypes.string,
};

export default SymbolEnvironmentBig;



// WEBPACK FOOTER //
// js/src/wheel/symbols/SymbolEnvironmentBig.js